import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Checkbox, Textarea } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { get } from 'lodash'
import { PROGRESS_STATES, RP_PROGRESS_STATES } from '../../../../constants/enums'

@form({
  form: 'taskApprove'
})
class TaskApprove extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    intlKey: PropTypes.string,
    handleSubmit: PropTypes.func,
    modal: PropTypes.func.isRequired,
    approve: PropTypes.func.isRequired,
    withNote: PropTypes.bool,
    submitting: PropTypes.bool,
    isActivityTask: PropTypes.bool,
    isAssessorWelcomeEmailEnabled: PropTypes.bool,
    isAssessorManagementEnabled: PropTypes.bool,
    isAssessorRegistrationApproval: PropTypes.bool,
    isWWCUpdate: PropTypes.bool,
    validationData: PropTypes.object,
    activityState: PropTypes.object,
    isLoading: PropTypes.bool
  }

  static defaultProps = {
    title: 'Approve',
    intlKey: 'tasks.approve_item',
    withNote: false,
    isActivityTask: false
  }

  handleDismiss = () => this.props.modal(null)

  render() {
    const {
      handleSubmit,
      approve,
      id,
      title,
      intlKey,
      withNote,
      isActivityTask,
      isAssessorWelcomeEmailEnabled,
      isAssessorManagementEnabled,
      isAssessorRegistrationApproval,
      isWWCUpdate,
      validationData,
      activityState,
      isLoading
    } = this.props

    const warningsStateHoursCountCond = !get(validationData, 'isCompleted') && activityState === PROGRESS_STATES.awardLeaderSignoff.id

    return (
      <form onSubmit={handleSubmit(fields => approve(id, fields, isAssessorManagementEnabled))}>
        <h2 className="text--center">
          {isAssessorManagementEnabled ?
             <FormattedMessage id="states.authorize_activity" defaultMessage="Authorize Activity and Assessor"/>
              : <FormattedMessage id={intlKey} defaultMessage={title} />
          }?
        </h2>
        <div className="row">
          <div className="col-xs-12">
            {withNote && <Textarea name="note" label="Note" />}
        <br />
          {isAssessorWelcomeEmailEnabled && !isAssessorManagementEnabled && isActivityTask && <Checkbox
            label="Don't send welcome email to assessor"
            intlKey="label.prevent_welcome_email_assessor"
            name="preventSendEmailToAssessor"
          /> }
        </div>

          {isAssessorRegistrationApproval && <div className="row">
            <div style={{ textAlign: "center", marginBottom: "20px", width: "100%", padding: "10px" }}>
              <FormattedHTMLMessage
                id="label.confirm_assessor_registration"
                defaultMessage="You are confirming that you have reviewed and validated all working with children requirements for this person via the process required in your State/Territory."
              />
            </div>
          </div>}

          {isWWCUpdate && <div className="row">
            <div style={{ color: '#f70c4d', textAlign: "center", marginBottom: "20px", width: "100%", padding: "10px" }}>
              <FormattedHTMLMessage
                id="label.confirm_wwc_update"
                defaultMessage="By approving this updated reference number, you are acknowledging the this has been validated as correct by your Award Centre through the relevent State/Territory body."
              />
            </div>
          </div>}

          <div className="row">
            <div className="col-xs-12">

              {(activityState === PROGRESS_STATES.awardLeaderSignoff.id) && !get(validationData, 'isAssessmentPositive') && <div className="text--center" style={{ color: '#f70c4d', paddingBottom: 10, marginLeft: 10, marginRight: 10 }}>
                <FormattedHTMLMessage
                    id="states.change_to_state_warning_missing_assessment"
                    defaultMessage="WARNING: The assessment has not been added. Do you still want to proceed?"
                    values={{ state: activityState.label }}
                />
              </div>}

              {isAssessorManagementEnabled && (activityState === PROGRESS_STATES.activityApproval.id || activityState === RP_PROGRESS_STATES.rpApproval.id) && <div className="text--center" style={{ color: '#f70c4d', paddingBottom: 10, marginLeft: 10, marginRight: 10 }}>
                <b><FormattedHTMLMessage
                    id="states.authorize_activity"
                    defaultMessage="Authorize Activity and Assessor?"
                /></b>
                <br />
                <FormattedHTMLMessage
                    id="states.authorize_activity_description"
                    defaultMessage="By authorizing the activity and assessor, an invitation will be sent to the Assessor to become the participant's Assessor for this activity. By authorizing you are acknowledging that the person’s experience is relevant to the activity being undertaken."
                />
              </div>}

              {warningsStateHoursCountCond && <div className="text--center" style={{ color: '#f70c4d', paddingBottom: 10, marginLeft: 10, marginRight: 10 }}>
              <FormattedHTMLMessage
                  id="states.change_to_state_warning_missing_hours_to_complete"
                  defaultMessage="WARNING: The minimum hours required have not been recorded. Do you still want to proceed?"
              />
            </div>}
            </div>
          </div>

        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button type="button" secondary onClick={this.handleDismiss}>
              <FormattedMessage id="button.dismiss" defaultMessage="Dismiss" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button isLoading={isLoading}>
              {isAssessorManagementEnabled ? <FormattedMessage id="button.authorize" defaultMessage="Authorize" />
              : <FormattedMessage id="button.approve" defaultMessage="Approve" />}
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default TaskApprove
